import _ from 'lodash';
import CMSModel from '@/visa-application/models/CMSModel';
import { SocialMedia } from '@/visa-application/models/FooterLinkCMSModel';

export class FooterLogoCMSItemModel implements CMSModel {
  country_code = '';
  link = '';

  map(obj: any): void {
    this.country_code = _.get(obj, 'footer_logo_w3c_link[0].country_code', 'Undefined');
    this.link = _.get(obj, 'footer_logo_w3c_link[0].link', 'Undefined');
  }
}

export default class FooterCMSModel implements CMSModel {
  public facebook = '';
  public linkedin = '';
  public socialMedia: SocialMedia[] = [];
  public footer_logo_w3c_link: FooterLogoCMSItemModel = new FooterLogoCMSItemModel();
  public copyrights = '';

  public map(obj: any): void {
    this.facebook = _.get(obj, 'facebook', '');
    this.linkedin = _.get(obj, 'linkedin', '');
    this.socialMedia = _.get(obj, 'socialmedia', []);
    this.footer_logo_w3c_link = _.get(obj, 'footer_logo_w3c_link', {});
    this.copyrights = _.get(obj, 'translation[0].copyrights', '');
  }
}
